"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionCheck = void 0;
const Flag_1 = require("@opsbase/lib-issue/Flag");
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const useForceUpdate_1 = __importDefault(require("@opsbase/react-hooks/useForceUpdate"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const react_1 = __importStar(require("react"));
const OpPerformQuestionCard_1 = __importDefault(require("../../OpPerformQuestionCard"));
function OpPerformQuestionCheck(props) {
    const { rule, answer } = (0, usePerformQuestion_1.default)();
    const { doChangeAnswer } = (0, usePerformQuestionActions_1.default)();
    const { forceUpdate } = (0, useForceUpdate_1.default)();
    const { mode } = (0, usePerform_1.default)();
    const viewMode = mode === 'view';
    const handleChange = (0, useCallforward_1.default)(value => () => {
        doChangeAnswer({ value });
        forceUpdate();
    }, [doChangeAnswer, forceUpdate]);
    return (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        return (react_1.default.createElement(OpPerformQuestionCard_1.default, Object.assign({}, props, { disableChildren: viewMode }),
            react_1.default.createElement(Horizontal_1.default, { padding: true, gutter: true, style: { maxWidth: '100%' } },
                react_1.default.createElement(Pane_1.default, { grow: true }),
                react_1.default.createElement(CheckButton, { option: rule.yes, checked: answer.value === ((_a = rule.yes) === null || _a === void 0 ? void 0 : _a.value), onClick: handleChange((_b = rule.yes) === null || _b === void 0 ? void 0 : _b.value) }),
                react_1.default.createElement(CheckButton, { option: rule.no, checked: answer.value === ((_c = rule.no) === null || _c === void 0 ? void 0 : _c.value), onClick: handleChange((_d = rule.no) === null || _d === void 0 ? void 0 : _d.value) }),
                react_1.default.createElement(Pane_1.default, { grow: true }))));
    }, [answer, viewMode, handleChange, props, rule.no, rule.yes]);
}
exports.OpPerformQuestionCheck = OpPerformQuestionCheck;
exports.default = OpPerformQuestionCheck;
function CheckButton(props) {
    const { option, checked, onClick } = props;
    const color = (0, Flag_1.flagColor)(option === null || option === void 0 ? void 0 : option.flag);
    const [label] = (0, useAltForSelfLang_1.default)(option === null || option === void 0 ? void 0 : option.label, option === null || option === void 0 ? void 0 : option.labelAlt);
    if (!option)
        return null;
    return (react_1.default.createElement(Button_1.default, { style: { width: 152, maxWidth: '50%', minWidth: 'unset' }, maxLabelWidth: 120, color: checked ? color : lib_palette_1.default.LavendarGrey, label: label, tooltip: label, onClick: onClick }));
}
